import * as React from "react";
import { useNavigate, useLocation } from "react-router";
import { ulid } from "ulid";

export const OpenChatView: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const conversationId = ulid();
    navigate(`/open-chat/${conversationId}`, {
      state: location.state, // Forward any state (including message) to the conversation
    });
  }, [navigate, location.state]);

  return null;
};
